import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    UiCol,
    UiRowContainer,
    UiSingleRow,
} from "../../../components/grid-container/GridContainer";
import {
    UiContentWr,
    UiContentCol,
    UiTabContentWr,
} from "../../../components/common/UiPageElements";
import UiMainWrapper from "../../../components/common/UiMainWrapper";
import CustomTopHeader from "../../../../_uiComponents/common/custom/header/CustomTopHeader";
import CustomFooter from "../../../../_uiComponents/common/custom/footer/CustomFooter";
import IncentiveBanner from "../views/IncentiveBanner";
import nyImage from "../../../../../styles/img/custom/image-01.png";
import nyImage2 from "../../../../../styles/img/custom/image-02.png";
import nyImage3 from "../../../../../styles/img/custom/image-03.png";
import nyImage4 from "../../../../../styles/img/custom/image-04.png";
import { UiBannerBottomBar } from "../../../components/common/UiBannerBottomBar";
import { IncentivesQuickRead } from "../views/QuickRead";
import { TermsConditionsQ3 } from "../views/TermsConditionsQ3";
import { Faq } from "../views/Faq";
import SliderCardImage from "../../../../../styles/img/custom/renault-top-right-image.png";
import { TickIcon } from "../../../../../styles/img/svg/TickIcon";
import { UiLeftContentRightImageBlock } from "../../../components/common/UiImageBlock";
import { UiAccordion } from "../../../components/common/UiAccordion";
import LeagueTableTeam from "./LeagueTableTeam";
import {
    UiScrollNavWr,
    UiScrollNavItem,
} from "../../../components/common/UiScrollToElements";
import RealTimeCodeEntry from "../views/RealTimeCodeEntry";
import { HowIncentiveWorks } from "./HowIncentiveWorks";
import TeamMemberTable from "./TeamMemberTable";
import RewardChoice from "./RewardChoice";
import { QuickReadSection } from "./QuickReadSection";

import UiCustomWr from "../../../../_uiComponents/common/custom/UiCustomWr";
import TeamMemberTableIncentive from "./TeamMemberTableIncentive";
import {
    userTypes,
    participantJobRoleIds,
    participantTypeIds
} from "../../../../../_redux/_constants";
import WearAndTearChart from "../../../../pages/incentive/views/WearAndTearChart";
import NationalPerformanceChart from "../../../../pages/incentive/views/NationalPerformanceChart";
import CurrentCampaigns from "../../../../pages/incentive/views/CurrentCampaigns";
import { useLogContentPageView } from "../../../../pages/common/LogContentPageView";
import UiDealerSelect from "../../../../_uiComponents/common/UiDealerSelect";
import { campaignGetWareAndTireSummaryRequest } from "../../../../../_redux/_actions";

export default function ProductTargetIncentives(props) {
    const logPageView = useLogContentPageView();
    const actionDispatch = useDispatch();
    const [dealer, setDealer] = useState(null);

    useEffect(() => {
        logPageView(1, 290);
    }, []);

    const { areaManagerDealers, userProfileDetails } = useSelector((state) => {
        return {
            areaManagerDealers: state.campaign,
            userProfileDetails: state.auth.userProfileDetails,

        };
    });

    const TableHeaders = [
        { id: 1, th: "Rank" },
        { id: 2, th: "Name" },
        { id: 3, th: "Sales" },
        { id: 4, th: "Location" },
        { id: 5, th: "Department" },
    ];

    const wizardData = [
        {
            id: 1,
            number: "1",
            title: "Step 1",
            content:
                "What percentage of retail visits have an eVHC Carried out? (Target >90%)",
            // status: "active",
        },
        {
            id: 2,
            number: "2",
            title: "Step 2",
            content: "What is your percentage of Red Upsell? (Target >70%)",
        },
        {
            id: 3,
            number: "3",
            title: "Step 3",
            content:
                "Ask why customers are not authorising Red Work? look for trends.",
        },
        {
            id: 5,
            number: "4",
            title: "Step 4",
            content:
                "Are you promoting the benefits of genuine parts?",

        },
    ];

    const managerWizardData = [
        {
            id: 1,
            number: "1",
            title: "Step 1",
            content:
                "What percentage of retail visits have an eVHC Carried out? (Target >90%)",
            // status: "active",
        },
        {
            id: 2,
            number: "2",
            title: "Step 2",
            content: "What is your percentage of Red Upsell? (Target >70%) ",
        },
        {
            id: 2,
            number: "3",
            title: "Step 3",
            content:
                "Are you asking your Service Team for reasons why customers are not authorising Red Work and recording this? (Keep a log and look for trends) ",
        },
        {
            id: 5,
            number: "4",
            title: "Step 4",
            content:
                "Is your team selling the benefits of genuine parts?",

        },
    ];

    const termsConditions = [
        {
            id: 1,
            title: "How to participate",
            description:
                "Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.",
        },
        {
            id: 2,
            title: "The clock is ticking",
            description:
                "Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.",
        },
    ];

    const managerFaq = [
        {
            id: 1,
            title: "Can Service Managers earn 10000 points (£100) if their team hits their target?",
            description: (
                <>The 10000 reward points are for Service Advisors only</>
            ),
        },
        {
            id: 2,
            title: "How many points = £1?",
            description: "100 points = £1",
        },
        {
            id: 3,
            title: "What is the reward for Service Managers?",
            description:
                "The Service Manager who outperforms their peers and against their 12-month objective will win a trip Abu Dhabi – see the incentive campaign page for more information and targets",
        },
        {
            id: 4,
            title: "How do my team receive their points?",
            description: (
                <>
                    <p>
                        We will report your Team's points earning progress
                        throughout the campaign and you will be required to
                        allocate points in accordance with achievements at
                        campaign close.
                    </p>
                    <p>
                        Points will then be made automatically available to team
                        members within their Points Bank.
                    </p>
                </>
            ),
        },
        {
            id: 5,
            title: "Do I have to allocate points equally?",
            description: (
                <>
                    <p>
                        Yes, but this should only be to Service Advisors who
                        have been active in the campaign
                    </p>
                    <p>
                        You can decide to use the points to purchase a team
                        reward from the shop
                    </p>
                </>
            ),
        },
        {
            id: 6,
            title: "Who do I contact if I need support with Équipe?",
            description:
                "For Campaign support head to the CNQR platform and select aftersales/aftersales incentive as the topic.",
        },
    ];

    const advisorFaq = [
        {
            id: 1,
            title: "How many do I need to sell?",
            description: (
                <p>
                    The measurement of success in this campaign is based on your
                    team achieving and/or exceeding the combined sales price
                    value of the included Wear & Tear products. This score is
                    calculated according to the total sales value of the
                    campaign products (zero being applied for a product that has
                    not been included in a customer transaction) divided by the
                    number of customer transactions that your team makes during
                    the campaign period.
                </p>
            ),
        },
        {
            id: 2,
            title: "How many points = £1?",
            description: "100 points = £1",
        },
        {
            id: 3,
            title: "What is the reward if I hit target?",
            description: (
                <p>
                    10000 reward points (£100) each if your team hits target.
                    Only team members registered on Équipe will receive a
                    reward.
                </p>
            ),
        },
        {
            id: 4,
            title: "How do I receive this reward?",
            description: (
                <>
                    <p>
                        Your manager will be required to allocate reward points
                        to active team members at campaign close. This will be
                        no earlier than 5 working days after the campaign close
                        date.
                    </p>
                    <p>
                        Points will then be made automatically available to team
                        members within their Points Bank
                    </p>
                    <p>
                        Your manager may choose to spend the points on a team
                        reward
                    </p>
                </>
            ),
        },
        {
            id: 5,
            title: "How long will it take to receive my points?",
            description: (
                <>
                    <p>5-7 working days post quarter</p>
                </>
            ),
        },
        {
            id: 6,
            title: "How do I spend my points?",
            description: "You can spend your points in the Équipe Shop",
        },
        {
            id: 7,
            title: "Who do I contact if I need support with Équipe?",
            description: (
                <>
                    <p>
                        For Campaign support head to the CNQR platform and
                        select aftersales/aftersales incentive as the topic.
                    </p>
                </>
            ),
        },
    ];

    const { latestAchievements, thingsToDo, auth } = useSelector((state) => {
        return {
            auth: state.auth,
        };
    });

    const options = [
        { value: "earn", label: "January111" },
        { value: "rewards", label: "February" },
    ];


    const ChangeDropDown = (value) => {
        setDealer(value);
            actionDispatch(campaignGetWareAndTireSummaryRequest({
                campaign:'q3',
                salesQuarter:3,
                dealerCode:value?.value
            }));
    }


    return (
        <>
            <UiCustomWr>
                <UiMainWrapper>
                    <IncentiveBanner
                        topText="Team incentive"
                        title="Q3 Wear & Tear Service Advisor Incentive"
                        description="The campaign is now CLOSED and final results have been published."
                        sliderCardImage={SliderCardImage}
                    />

                    <UiContentWr>
                        <UiTabContentWr>
                            <UiRowContainer fluid="fluid">
                                <UiScrollNavWr>
                                    <UiScrollNavItem
                                        hash="About-the-campaign"
                                        hashText="About the campaign"
                                    />
                                    <UiScrollNavItem
                                        hash="National-performance"
                                        hashText="National performance"
                                    />
                                    <UiScrollNavItem
                                        hash="T-and-Cs"
                                        hashText="T&Cs"
                                    />
                                    <UiScrollNavItem
                                        hash="FAQs"
                                        hashText="FAQs"
                                    />
                                </UiScrollNavWr>
                            </UiRowContainer>
                        </UiTabContentWr>
                    </UiContentWr>

                    <UiContentWr id="About-the-campaign">
                        <UiRowContainer fluid="fluid">
                                <UiCol lg="4" className="sb-incentive-left-col">
                                    <UiContentCol>
                                    {userProfileDetails?.jobRoleId ==
                                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER &&

                                            <div className="sb-performance-dealer-select sb-quarter-dealer-select">
                                            <UiDealerSelect
                                                dealerOptions={areaManagerDealers?.areaManagerDealers.map(
                                                    (dealerships) => {
                                                        return {
                                                            value: dealerships.code,
                                                            label: dealerships.name,
                                                        };
                                                    },
                                                )}
                                                dealerships={areaManagerDealers?.areaManagerDealers}
                                                isDashBoard={false}
                                                selectDealer={true}
                                                onChange={(value) => ChangeDropDown(value)}
                                            />
                                            </div>
                                    }
                                            <WearAndTearChart
                                                campaign="q3"
                                                salesQuarter={3}
                                                dealer={dealer}
                                            />
                                        </UiContentCol>
                                    </UiCol>                                
                            <UiCol lg="8" className="sb-incetive-right-col">
                                <UiContentCol>
                                    <UiSingleRow>
                                        {auth?.userProfileDetails.jobRoleId &&
                                            auth?.userProfileDetails.jobRoleId ==
                                            participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR &&
                                            auth?.userProfileDetails.roleId ==
                                            participantTypeIds.PARTICIPANT ? (
                                            <UiCol lg="6">
                                                <div className="sb-incetive-right-col__right-section">
                                                    <div className="sb-incetive-right-col__content">
                                                        <h3>Final Results</h3>
                                                        <p>
                                                        As a Service Advisor you will have earned 10,000 (£100) reward point bonus if your team achieved its Q3 Wear and Tear campaign target.
                                                        Final data has been uploaded and winners have been notified.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="sb-incetive-right-col__content">
                                                    <h5>
                                                        Targets and measurement
                                                    </h5>
                                                    <p>
                                                        Targets were based on your ‘sales out’ at PNC value/paying customers on four key OE
                                                        (original equipment) parts:
                                                    </p>
                                                    <ul>
                                                        <li>Brake pads</li>
                                                        <li>Brake discs</li>
                                                        <li>12v batteries</li>
                                                        <li>Wiper blades</li>
                                                    </ul>
                                                </div>
                                                <div className="sb-incetive-right-col__content">
                                                    <h5>Example</h5>
                                                    <p>
                                                        If your total value of sales out across these four parts in the period was £2,000 and you had
                                                        400 total paying customers, your performance would be £5.00.
                                                    </p>
                                                    <p>
                                                        Q3 2024 targets were based on 2024 Q1, Q2 &amp; Q3 performance. Plus, growth, or the
                                                        minimum national target of £6 per paying entry.
                                                    </p>

                                                </div>
                                                {/* <div className="sb-incetive-right-col__content">
                                                    <h5>Retailer rewards</h5>
                                                    <p>
                                                        Quarterly reward: 10000 points (£100) per Service Advisor that meets the targets, paid as Points into your personal RG Équipe account for redemption against the extensive range of vouchers that are available through the site.
                                                    </p>
                                                </div> */}
                                            </UiCol>
                                        ) : <UiCol lg="6">
                                            <div className="sb-incetive-right-col__right-section">
                                                <div className="sb-incetive-right-col__content">
                                                    <h3>This Campaign is now closed</h3>
                                                    <p>
                                                        Your Service Advisors will have earned a 10,000 (£100) reward point bonus if your team achieved its Q3 Wear and Tear campaign target. Final data has been uploaded and winners have been notified.
                                                    </p>

                                                </div>
                                            </div>
                                            <div className="sb-incetive-right-col__content">
                                                <h5>Targets and measurement</h5>
                                                <p>
                                                    Targets were based on ‘sales out’ at PNC value/paying customers on four key OE (original
                                                    equipment) parts:
                                                </p>
                                                <ul>
                                                    <li>Brake pads</li>
                                                    <li>Brake discs</li>
                                                    <li>12v batteries</li>
                                                    <li>Wiper blades</li>
                                                </ul>
                                            </div>
                                            <div className="sb-incetive-right-col__content">
                                                <h5>Example</h5>
                                                <p>
                                                    If your total value of sales out across these four parts in the period was £2,000 and you had
                                                    400 total paying customers, your performance would be £5.00.
                                                </p>
                                                <p>
                                                    Q3 2024 targets were based on 2024 Q1, Q2 &amp; Q3 performance. Plus, growth, or the
                                                    minimum national target of £6 per paying entry.
                                                </p>

                                            </div>
                                            {/* <div className="sb-incetive-right-col__content">
                                                <h5>Retailer rewards</h5>
                                                <p>
                                                    Quarterly reward: 10000 points (£100) per Service Advisor that meets the targets, paid as Points into personal RG Équipe accounts for redemption against the extensive range of vouchers that are available through the site.
                                                </p>
                                            </div> */}
                                        </UiCol>}
                                        <UiCol lg="6">
                                            <div className="sb-incetive-right-col-img-section">
                                                <img src={nyImage} />
                                                <img src={nyImage2} />
                                                <img src={nyImage} />
                                                <img src={nyImage4} />
                                            </div>
                                        </UiCol>
                                    </UiSingleRow>
                                </UiContentCol>
                            </UiCol>
                        </UiRowContainer>
                    </UiContentWr>

                    <UiContentWr>
                        <UiRowContainer
                            fluid="fluid"
                            className="sb-league-tabl-sec"
                        >
                            <UiCol lg="12">
                                <UiContentCol>

                                    {auth?.userProfileDetails
                                        .jobRoleId &&
                                        auth?.userProfileDetails
                                            .jobRoleId ==
                                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR &&
                                        auth?.userProfileDetails
                                            .roleId ==
                                        participantTypeIds.PARTICIPANT ? (
                                        <QuickReadSection
                                            wizardData={wizardData}
                                        />
                                    ) : <QuickReadSection
                                        wizardData={managerWizardData}
                                    />}


                                </UiContentCol>
                            </UiCol>
                        </UiRowContainer>
                    </UiContentWr>

                    <UiContentWr id="National-performance">
                        <UiRowContainer
                            fluid="fluid"
                            className="sb-league-tabl-sec"
                        >
                            <UiCol lg="12">
                                <UiContentCol>
                                    <NationalPerformanceChart />
                                </UiContentCol>
                            </UiCol>
                        </UiRowContainer>

                    </UiContentWr>
                    {/* 
                    {auth?.userProfileDetails.jobRoleId &&
                        auth?.userProfileDetails.jobRoleId ==
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER &&
                                                auth?.userProfileDetails
                                                    .roleId ==
                                                    participantTypeIds.PARTICIPANT ? (
                        <UiContentWr id="Managers-dashboard">
                            <UiRowContainer
                                fluid="fluid"
                                className="sb-league-tabl-sec"
                            >
                                <UiCol lg="12">
                                    <UiContentCol>
                                        <UiSingleRow>
                                            <UiCol lg="12" xl="12">
                                                <TeamMemberTableIncentive />
                                            </UiCol>
                                        </UiSingleRow>
                                    </UiContentCol>
                                </UiCol>
                            </UiRowContainer>
                        </UiContentWr>
                    ) : null} */}
                    {/* {auth?.userProfileDetails.jobRoleId &&
                        auth?.userProfileDetails.jobRoleId ==
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR &&
                    auth?.userProfileDetails.roleId ==
                        participantTypeIds.PARTICIPANT ? (
                            <RewardChoice />
                        
                    ) :
                    <></>
                    } */}

                    <span id="T-and-Cs"></span>
                    <TermsConditionsQ3 />
                    <span id="FAQs"></span>
                    {auth?.userProfileDetails.jobRoleId &&
                        auth?.userProfileDetails.jobRoleId ==
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR &&
                        auth?.userProfileDetails.roleId ==
                        participantTypeIds.PARTICIPANT ? (
                        <Faq items={advisorFaq} />
                    ) : (
                        <Faq items={managerFaq} />
                    )}
                    <CurrentCampaigns />

                </UiMainWrapper>
            </UiCustomWr>
        </>
    );
}
